module.exports = __webpack_public_path__ + "static/media/SF_bm_primaerlogo_oslo_viken_pos.41bcccb5.svg";